export const tabNamesMap = {
    'C': 'Closed',
    'A': 'Active',
    'U': 'Upcoming',
    'D': 'In-Development',
    'R': 'Released',
    'N': 'Checklist NA',
    'DT_N': 'Data Tracker N/A',
    'DT_C': 'Data Tracker Complete',
    'DT_P': 'Data Tracker Pending',
    'DT_D': 'Data Tracker Matched/Duplicate',
    'DT_A': 'Data Tracker Progress',
    'DT_ALL': 'Data Tracker All',
    'DT_H':'Data Tracker On Hold',
    'FMP_P': 'Pending',
    'FMP_G': 'In Progress',
    'FMP_A': 'All',
    'FMP_R': 'Under Review',
    'FMP_B': 'As-Builts',
    'FMP_C': 'Complete'
    

}